// API Base URL configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.proviarcm.com';

// Helper to construct API URLs
export const getApiUrl = (path: string) => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
